<template>
  <div class="flex justify-between mt-2">
    <Button id="modal-button-cancel" type="secondary" @click="emit('dismiss')">
      {{ $t('ui.common.close') }}
    </Button>
    <ButtonDropdown
      id="modal-button-confirm"
      :label="$t('ui.common.add')"
      :disabled="disableConfirm"
      split
      @click="emit('confirm', 'close')"
    >
      <List>
        <ListItem
          id="modal-button-add-and-create-new"
          :disabled="disableConfirm"
          @click="emit('confirm', 'new')"
        >
          {{ $t('ui.common.add_and_create_new') }}
        </ListItem>
        <ListItem
          id="modal-button-add-and-create-similar"
          :disabled="disableConfirm"
          @click="emit('confirm', 'similar')"
        >
          {{ $t('ui.common.add_and_create_similar') }}
        </ListItem>
      </List>
    </ButtonDropdown>
  </div>
</template>

<script lang="ts" setup>
import Button from '@/components/controls/Button'
import ButtonDropdown from '@/components/controls/ButtonDropdown'
import { List, ListItem } from '@/components/misc/List'
import type { ModalConfirmBehave } from '@/types/components/modal'

defineProps({
  disableConfirm: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits<{
  confirm: [ModalConfirmBehave]
  dismiss: []
}>()
</script>
